import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_209: DocMigration = {
  maxSchemaVersion: "0.0.209",
  description: "Add optionSetRefs table to Doc",
  apply(json: any) {
    if (!json.optionSetRefs) {
      json.optionSetRefs = {};
    }

    return json;
  },
};

export default migration_0_0_209;
